import { useParams, useLocation } from "react-router-dom";
import React, { useEffect, useState, useCallback } from "react";
import api from "../../api";

import { Modal } from "react-bootstrap";

import "bootstrap/js/dist/modal.js";

import ModalComponentN5 from "../../components/Modal/ModalComponentN5";
import Loading from "../../components/Loading";
import IGVBrowser from "../../components/igv/IGVBrowser";

export default function SearchN5Table() {
    const params = useParams();
    const location = useLocation();
    const [N5Data, setN5Data] = useState([]);
    const [loading, setLoading] = useState(true);

    const [show, setShow] = useState(false);
    const [dataModal, setDataModal] = useState("");

    const fetchN5Records = useCallback(() => {
        let searchAdvanced = false;
        const formData = new FormData();

        if (location?.search) {
            searchAdvanced = true;
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.forEach((v, k) => {
                formData.append(`filter[${k}]`, v);
            });
        }

        const urlParamsData = new URLSearchParams(formData);
        const sendParam = searchAdvanced ? urlParamsData : `filter[search]=${params?.name}`;

        api.get(`/search/n5?${sendParam}`)
            .then((response) => {
                const data = response.data;
                setN5Data(data.data);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
            });
    }, [params?.name, location]);

    useEffect(() => {
        if (params?.name) {
            fetchN5Records();
        }
    }, [params, fetchN5Records]);

    if (loading) return <Loading />;

    return (
        <div className="container">
            {/* <div className="my-5"></div> */}
            <div className="h5 mb-4">Search : {params?.name}</div>

            <div className="table-responsive">
                <table className="table caption-top table-striped table-bordered">
                    <caption>Gene</caption>
                    <thead>
                        <tr>
                            <th scope="col" className="font-monospace">
                                Chromosome No
                            </th>
                            <th scope="col" className="font-monospace text-end">
                                Type
                            </th>
                            <th scope="col" className="font-monospace text-end">
                                Position Start
                            </th>
                            <th scope="col" className="font-monospace text-end">
                                Position Stop
                            </th>
                            <th scope="col" className="text-center">
                                {/* การดำเนินการ */}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {N5Data.length > 0 ? (
                            N5Data.map((item) => {
                                return (
                                    <tr key={item?.id}>
                                        <th scope="row" className="font-monospace">
                                            {item?.chromosome_no}
                                        </th>
                                        <td className="font-monospace text-end">{item?.type}</td>
                                        <td className="font-monospace text-end">{item?.position_start}</td>
                                        <td className="font-monospace text-end">{item?.position_stop}</td>
                                        <td className="text-center">
                                            <button
                                                className="btn btn-outline-primary btn-sm"
                                                onClick={() => {
                                                    setShow(true);
                                                    setDataModal(item);
                                                }}
                                            >
                                                อ่านเพิ่มเติม
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td className="text-center" colSpan={5}>
                                    ไม่พบข้อมูลที่Search
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>

                <div className="mt-4"></div>
                
                {N5Data.length > 0 && <IGVBrowser position={N5Data[0].position_start} chromosome={N5Data[0].chromosome_no} />}
            </div>

            <Modal show={show} fullscreen={true} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title className="font-monospace">Gene Data</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalComponentN5 data={dataModal} />
                </Modal.Body>
            </Modal>

            <br />
            <br />
            <br />
        </div>
    );
}
